import AppNavigationProvider from '../provider/AppNavigationProvider';

const PublicRoute = ({ children }) => {
  return <AppNavigationProvider>{children}</AppNavigationProvider>;
};

export default PublicRoute;
